import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStackedBarChartHorizontal100Axis: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconStackedBarChartHorizontal100Axis"><Path d="M3 3H5V19H21V21H3V3Z" fill="currentColor"/><Path d="M12 15V17H6V15H12ZM20 15V17H14V15H20ZM11 10.5V12.5H6V10.5H11ZM20 10.5V12.5H13V10.5H20ZM14 6V8H6V6H14ZM20 6V8H16V6H20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStackedBarChartHorizontal100Axis;
